export default __webpack_public_path__ + "static/media/homeLP.29de7bd7.csv";